<template>
    <div id="pageContent" style="display: flex;flex-direction: column;
    height: 100%;
    ">
        <div :style="{ height: contentHeight + 'px' }" style="width: 100%;overflow: auto;  scrollbar-width: none;
  -ms-overflow-style: none; ">
            <div class="columnformat">
                <div
                    style="font-weight: 700;color: #EA9518;text-align: left;width: calc(90% - 20px);background:white;border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);padding: 10px;margin: 10px 0;">
                    {{ orderInfo.statusStr }}
                </div>
                <div
                    style="border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);background: white;width: calc(90% - 20px);padding: 10px;margin: 10px 0;display: flex;flex-direction: column;">
                    <div
                        style="display: flex;align-items: center;justify-content: space-between;font-weight: 700;color: black;padding: 10px 0;">
                        商品费用
                    </div>
                    <div v-for="item, index in orderInfo.itemList" :key="index"
                        style="background: white;width: 100%;padding: 5px 0;margin-bottom: 5px;display: flex;">
                        <img v-if="item.info.itemHeadImg" style="width: 80px;height: 80px;object-fit:cover;border-radius:10px;"
                            :src="resourceBase + '/assets/itemImg/' + (item.info.itemHeadImg || '').split(';')[0]"
                            alt="">
                        <div v-else style="width:80px;height:80px;flex-shrink:0;background:#f5f5f5;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">商品图片</div>
                        <div
                            style="display: flex;flex-direction: column;justify-content: space-between;height: 100%;margin-left: 10px;flex: 1;">

                            <div
                                style="width: 100%;display: flex;align-items: center;justify-content: space-between;color: black;">
                                <div style="
                                    text-align: left;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    flex: 1;
                                    ">{{ item.info.itemName }}</div>
                                <div style="display: flex;align-items: center;">
                                    实付：¥<div style="font-weight: 700;font-size: large;">{{ item.info.itemPrice }}</div>
                                </div>
                            </div>


                            <div style="width: 100%;display: flex;flex-direction: column;color: grey;font-size: small;">

                                <div style="font-weight: 700;width: 100%;text-align: left;">单价：¥{{
                                    item.info.itemPrice }}元
                                </div>

                                <div style="width:100%;text-align: left;">
                                    数量：{{ item.itemNum }}
                                </div>
                                <div></div>

                            </div>
                        </div>
                    </div>
                    <div
                        style="display: flex;align-items: center;justify-content: space-between;font-weight: 700;color: black;padding: 10px 0;">
                        <div>商品总价</div>
                        <div>¥{{ orderInfo.total }}</div>
                    </div>
                    <div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;">
                        <div>配送费</div>
                        <div>¥{{ orderInfo.deliveryFee }}</div>
                    </div>
                    <div
                        style="display: flex;align-items: center;justify-content: flex-end;border-top: solid 2px #F5F5F5;padding: 10px 0;align-items: flex-end;">
                        <div>{{ Number(orderInfo.status) === 0 ? '应付款' : '实付款' }}</div>
                        <div style="font-weight: 700;font-size: x-large;color: #EA9518;margin-left: 10px;">¥{{
                            (Number(orderInfo.total) + Number(orderInfo.deliveryFee) - Number(orderInfo.couponDiscount || 0)).toFixed(2) }}</div>
                    </div>
                </div>
                <div
                    style="font-weight: 700;color: white;text-align: left;width: calc(90% - 20px);background:#EA9518;border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);padding: 10px;margin-bottom: 10px;display: flex;justify-content: space-between;">
                    <div>地址信息</div>
                </div>

                <div
                    style="color: grey;font-weight: 700;text-align: left;width: calc(90% - 20px);background:white;border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);padding: 10px;margin-bottom: 10px;display: flex;flex-direction: column;">
                    <div style="font-weight: 700;color: black;">预约信息</div>
                    <div style="margin-top: 10px;display: flex;align-items: center;font-weight: 300;">
                        <div style="color: black;margin-right: 10px;">联系方式</div>
                        <div>{{ orderInfo.taddress.contact }}</div>
                        <div style="margin-left: 10px;">{{ orderInfo.taddress.phoneNumber }}</div>
                    </div>
                    <div style="margin: 10px 0;display: flex;font-weight: 300;">
                        <div style="color: black;margin-right: 10px;">上门地址</div>
                        <div style="flex: 1;">{{ orderInfo.taddress.location }}{{ orderInfo.taddress.detailAddress }}
                        </div>
                    </div>
                    <!-- <div style="margin: 10px 0;display: flex;font-weight: 300;">
                        <div style="color: black;margin-right: 10px;">预约时间</div>
                        <div style="display: flex;align-items: center;">{{ orderInfo.date }}</div>
                        <div style="display: flex;align-items: center;margin-left: 10px;">{{ orderInfo.start }}</div>
                    </div> -->
                </div>

                <div
                    style="color: grey;font-weight: 700;text-align: left;width: calc(90% - 20px);background:white;border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);padding: 10px;margin-bottom: 10px;display: flex;flex-direction: column;">
                    <div style="margin-top: 10px;display: flex;align-items: center;justify-content: space-between;">
                        <div>订单号</div>
                        <div>{{ orderInfo.id }}</div>
                    </div>
                    <!-- <div style="margin: 10px 0;display: flex;align-items: center;justify-content: space-between;">
                        <div>下单时间</div>
                        <div>{{ }}</div>
                    </div> -->
                </div>

                <div
                    style="color: grey;font-weight: 700;text-align: left;width: calc(90% - 20px);background:white;border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);padding: 10px;margin-bottom: 10px;display: flex;flex-direction: column;">
                    <div style="margin-bottom: 10px;">购买须知</div>
                    <div style="display: flex;margin-bottom: 10px;">
                        <div style="flex-shrink: 0;">1.退款规则:</div>
                        <div v-if="orderInfo.orderType >= 9" style="flex: 1;margin: 0 10px;">
                            预约后服务前3小时可随时退款，此后需联系商户取消预约后退款。</div>
                        <div v-else style="flex: 1;margin: 0 10px;">骑手取货前可退</div>
                    </div>
                    <div style="display: flex;margin-bottom: 10px;">
                        <div style="flex-shrink: 0;">2.台规提示:</div>
                        <div style="flex: 1;margin: 0 10px;">
                            联系信息作为提供服务的必要信息将会发送给商户。
                        </div>
                    </div>
                    <div style="display: flex;margin-bottom: 10px;">
                        <div style="flex: 1;margin: 0 10px;">
                            为保护未成年人健康成长，未成年用户请得到监护人知悉同意后再进行购买和体验，请勿购买不适合自身年龄段的产品
                        </div>
                    </div>
                </div>
                <div style="
                    width: calc(100% - 20px);
                    display: flex;
                    flex-direction: column;
                    height: 100px;
                    ">
                     <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
                    <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
                </div>
            </div>
        </div>
        <div v-if="orderInfo.status !== 1" style="
            width: calc(100% - 20px);
           
            display: flex;
            flex-direction: column;
            position: fixed;
            background: white;
            bottom: 0;
            padding: 10px 10px 20px 10px;
            left: 0;
            ">
            <div style="width: 100%;display: flex;align-items: center;margin-bottom: 10px;">
                <div style="font-weight: 700;font-size: large;display: flex;align-items: center;">
                    <div style="font-weight: 500;display: flex;align-items: center;">合计</div>
                    <div style="display: flex;align-items: center;margin-left: 10px;">
                        ¥{{ (Number(orderInfo.total) + Number(orderInfo.deliveryFee) - Number(orderInfo.couponDiscount || 0)).toFixed(2) }}
                    </div>
                </div>
            </div>
            <div v-if="orderInfo.status == 0" @click="gotoCashier"
                style="width: 100%;background: #EA9518;color: white;padding: 10px 0;border-radius: 5px;font-weight: 700;font-size: large;height: 25px;">
                立即支付</div>
            <div v-if="orderInfo.status == 2 || orderInfo.status == 3 || orderInfo.status == 4 || orderInfo.status == 5"
                style="width: 100%;padding: 10px 0;border-radius: 5px;height: 25px;display: flex;align-items: center;justify-content: flex-end;">
                <el-button @click="cancelOrder" type="danger">取消订单</el-button>
                <el-button @click="createChatRomm" type="primary">联系商家</el-button>
            </div>
            <div v-if="orderInfo.status == 6"
                style="width: 100%;padding: 10px 0;border-radius: 5px;height: 25px;display: flex;align-items: center;justify-content: flex-end;">
                <el-button @click="writeComment" type="warning">写评价</el-button>
               
            </div>
        </div>
         
    </div>
</template>

<style scoped>
.columnformat {

    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F0F5F4;
    overflow: auto;
}
</style>

<script>
import request from "../axios/request";
import { cancelDemoOrder, getDemoOrder, isDemoOrder } from '@/utils/demoStore';
export default {
    data() {
        return {
            contentHeight: null,
            id: null,
            orderInfo: null,
            resourceIp: null,
            resourceBase: /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? 'https://yuanhuihuanhuan.com' : window.location.origin
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.resourceIp = this.extractIPFromURL(window.location.origin);
        this.getOrderInfo()
        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {
                    this.contentHeight = window.innerHeight - 50 - this.$store.state.indexBarHeight
                }
            });
        });
        resizeObserver.observe(document.getElementById("pageContent"));
    },
    methods: {
        writeComment(){
            this.$router.push({
                path:'/writeComment/'+this.id+'/'+this.orderInfo.companyId
            })    
        },
        async createChatRomm() {
            if (isDemoOrder(this.id)) {
                this.$message.info('当前订单暂不支持在线联系，请稍后重试或联系平台客服')
                return
            }
            let res = await request({
                url: "/chat/api/createChatRoom",
                method: "POST",
                data: {
                    userId: JSON.parse(localStorage.getItem("userInfo")).id,
                    companyId: this.orderInfo.companyId
                }
            })
            if (res.data.status == 200) {
                this.$router.push({
                    path: '/message/' + res.data.data
                });
            }
        },
        async cancelOrder() {
            if (isDemoOrder(this.id)) {
                cancelDemoOrder(this.id)
                this.$message.success('订单已取消')
                this.getOrderInfo()
                return
            }
            this.$confirm('确定要取消吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                showClose: false,
            }).then(async () => {
                let res = await request({
                url: Number(this.orderInfo.status) === 0 ? '/api/pay/web/' + this.id + '/cancel' : '/order/api/cancelOrder?orderId=' + this.id,
                    method: "post"
                });
                if (res.data.status == 200) {
                    this.getOrderInfo()
                }

            }).catch((e) => {
                console.log(e);

                console.log("已取消删除");
            });
        },
        gotoCashier() {
            this.$router.push({
                path: '/cashier/' + this.id
            })
        },
        async payOrder() {
            this.gotoCashier()
        },
        extractIPFromURL(url) {
            try {
                // 方法1：优先使用浏览器原生URL对象解析（兼容现代浏览器）
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // 如果是IPv6地址（如[2001:db8::1]），去除方括号
                if (hostname.startsWith('[') && hostname.endsWith(']')) {
                    return hostname.slice(1, -1);
                }

                // 如果是IPv4地址或域名，直接返回
                return hostname;
            } catch (e) {
                // 方法2：URL对象解析失败时，使用正则表达式作为兜底方案
                const ipv4Regex = /(?:\d{1,3}\.){3}\d{1,3}/; // 匹配IPv4
                const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i; // 匹配域名[1,4](@ref)

                // 尝试匹配IPv4
                const ipMatch = url.match(ipv4Regex);
                if (ipMatch) return ipMatch[0];

                // 尝试匹配域名
                const domainMatch = url.match(domainRegex);
                if (domainMatch && domainMatch[1]) {
                    return domainMatch[1].replace(/^www\./, ''); // 可选：去除www前缀
                }

                return null; // 均未匹配时返回null
            }
        },
        async getOrderInfo() {
            const demoOrder = getDemoOrder(this.id)
            if (demoOrder) {
                for (const orderItem of (demoOrder.itemList || [])) {
                    if (!orderItem.info || !orderItem.info.itemHeadImg) {
                        const itemRes = await request({
                            url: '/item/api/getItemDetailById?itemId=' + orderItem.itemId,
                            method: 'get'
                        })
                        if (itemRes.data.status == 200 && itemRes.data.data) {
                            orderItem.info = { ...(orderItem.info || {}), ...itemRes.data.data }
                        }
                    }
                }
                this.orderInfo = demoOrder
                return
            }
            let res = await request({
                url: "/order/api/getOrderInfo/" + this.id,
                method: "GET"
            })
            if (res.data.status == 200) {
                this.orderInfo = res.data.data
            }
        }
    }
}
</script>
